import { render, staticRenderFns } from "./richWarpText.vue?vue&type=template&id=7f0989e6&scoped=true&"
import script from "./richWarpText.vue?vue&type=script&lang=js&"
export * from "./richWarpText.vue?vue&type=script&lang=js&"
import style0 from "./richWarpText.vue?vue&type=style&index=0&id=7f0989e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0989e6",
  null
  
)

export default component.exports